module.exports = __webpack_public_path__ + "img/IMG_6726_L.c773199a.webp";